import { Button, Modal, Table } from 'antd';
import { type IUser } from '../../../../types/user';
import { useGetBreadcrumbs } from '../../../../services/breadcrumbs';

interface Props {
    onClose: () => void
    visible: boolean
    user: IUser
}

const BreadcrumbsModal = ({ user, onClose, visible }: Props) => {
    const { breadcrumbs, loading, refetch } = useGetBreadcrumbs(user?._id);
    const dataSource = (breadcrumbs || []).map((b: { action: string, createdAt: string }, index: number) => ({
        key: `${b.createdAt}-${b.action}-${index}`,
        action: b.action,
        createdAt: b.createdAt
    }));

    const columns = [
        {
            title: 'Acción',
            dataIndex: 'action',
            key: 'action'
        },
        {
            title: 'Fecha',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (value: string) => new Date(value).toLocaleString()
        }
    ];
    return (
        <Modal
            className='alloweance-modal'
            open={visible}
            onCancel={onClose}
            cancelText="Cerrar"
            title="Últimos movimientos"
        >
            <p>Aquí puedes ver los últimos movimientos de tus usuarios</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '12px 0' }}>
                <strong>Historial de acciones</strong>
                <Button onClick={refetch} loading={loading} type="primary">Refrescar</Button>
            </div>
            <Table
                size="small"
                bordered
                loading={loading}
                dataSource={dataSource}
                columns={columns as any}
                pagination={{ pageSize: 8 }}
            />
        </Modal>
    );
};

export { BreadcrumbsModal };
